import clsx from 'clsx'
import React, {useContext} from 'react'
import {Link, useHistory, useLocation} from 'react-router-dom'
import {makeStyles} from 'external/material'

import Box from '@mui/material/Box'

import {TeacherContext} from 'teacher/context'

import filterStyles from './styles'
import RepositoryFilter from './repository'
import SubjectFilter from './subject'
import CourseFilter from './course'
import UnitFilter from './unit'
import LessonFilter from './lesson'
import QuestionTypeFilter from './question-type'
import PatternFilter from './pattern'

import FilterChip from 'components/quiz/components/filter-chip'

const useStyles = makeStyles(filterStyles)


export default function QuestionBankFilters() {

  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()
  const context = useContext(TeacherContext)
  const {tab, link, linkQuery, translate, updateState} = context

  const createFilterHandler = (name, mapQuery) => (event) => {
    const value = event.target.value == '' ? undefined : event.target.value
    const query = mapQuery
      ? mapQuery(context.query, value)
      : {...context.query, [name]: value}
    history.push(linkQuery(location.pathname, {...query}))
  }

  function clearStandardFilters () {
    updateState({
      quizStandardFiltersCalls: {$apply: i => i + 1},
      quizStandardFilters: {expectations: {$set: []}, indicators: {$set: []}, standards:{$set: []}}
    })
  }
  
  const hasStandardsChip = Object.values(context.quizStandardFilters).some(a => a.length > 0)
  const hasChips = !(!context.query.pattern && !context.query.id && !hasStandardsChip)

  return (
    <Box className={classes.filters}>
      <Box className={classes.top}>
        <RepositoryFilter classes={classes} onChange={createFilterHandler('repository')} />
        <PatternFilter classes={classes} />
        <Box className={classes.filler} />
      </Box>
      <Box className={classes.bottom}>
        <SubjectFilter
          classes={classes}
          onChange={createFilterHandler('subject', (query, subject) => ({...query, course: undefined, unit: undefined, lesson: undefined, subject}))} 
        />
        <CourseFilter
          classes={classes}
          onChange={createFilterHandler('course', (query, course) => {
            return course
              ? {...query, course, subject: course.substring(0,2), unit: undefined, lesson: undefined}
              : {...query, course: undefined, unit: undefined, lesson: undefined}
          })}
        />
        <UnitFilter
          classes={classes}
          onChange={createFilterHandler('unit', (query, unit) => {
            return unit
              ? {...query, unit}
              : {...query, unit: undefined, lesson: undefined}
          })}
        />
        <LessonFilter
          classes={classes}
          onChange={createFilterHandler('lesson', (query, lesson) => {
            return lesson
              ? {...query, lesson}
              : {...query, lesson: undefined}
          })}
        />
        <QuestionTypeFilter
          classes={classes}
          onChange={createFilterHandler('type')}
        />
        <Box className={classes.filler} />
      </Box>
      <Box className={clsx(classes.chips, {hasChips})}>
        {context.query.pattern && <FilterChip name="pattern" context={context} from={location.pathname} />}
        {context.query.id && <FilterChip name="id" context={context} createLabel={() => translate('new-bank-question')} from={location.pathname} />}
        {hasStandardsChip && <FilterChip name="standards" context={context} createLabel={() => translate('standards-filter-chip')} from={location.pathname} onDelete={clearStandardFilters} />}
      </Box>
    </Box>
  )
}
